export function GetRequest(to) {
    let url = to || ''
    let theRequest = {}
    if (url.indexOf('?') !== -1) {
      let str = url.split('?')[1]
      let strs = str.split('&')
      for (let i = 0; i < strs.length; i++) {
        var temp = strs[i].split('=')
        var index = temp[1] && temp[1].indexOf('#')
        if (index > -1) {
          temp[1] = temp[1].slice(0, index)
        }
        theRequest[temp[0]] = unescape(temp[1])
      }
    }
    return theRequest
  }
// 身份证号码验证
  export function validateIdCard(idCard) {
    var identNumber = idCard;
    if (!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(identNumber))) {
        return false;
    }
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(identNumber))) {
        return false;
    }
    //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    //下面分别分析出生日期和校验位
    var len, re;
    len = identNumber.length;
    //判断18位身份证号码，现在在国家统一身份证为18位。
    if (len == 18) {
        re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        var arrSplit = identNumber.match(re);
        //检查生日日期是否正确
        var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
        var bGoodDay;
        bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
            return false;
        } else {
            //检验18位身份证的校验码是否正确。
            //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            var valnum;
            var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
            var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
            var nTemp = 0, i;
            for (i = 0; i < 17; i++) {
                nTemp += identNumber.substr(i, 1) * arrInt[i];
            }
            valnum = arrCh[nTemp % 11];
            if (valnum != identNumber.substr(17, 1)) {
                return false;
            } else {
                return true
            }
        }
    } else {
        return false;
    }
}
// 手机号码
export function validatePhone(e) {
    if (e.length == 11) {
        if (!/1(3|4|5|6|7|8|9)\d{9}/.test(e)) {
            return false
        } else {
            return true
        }
    }
}